import { observer } from 'mobx-react-lite';
import { AppRoutes } from '~/app/app.routes';
import { Col } from '../view.box';
import { LinkView } from '../view.link';
import { FeedbackDrawerItem, FeedbackDrawerTitle, FeedbackDrawerValue } from './feedback.drawer';
import { useFeedbackDrawerContext } from './feedback.drawer.ctx';

export const FeedbackDrawerUser = observer(() => {
	const { selectedItem } = useFeedbackDrawerContext();
	if (!selectedItem) return null;

	return (
		<Col gap={1}>
			<FeedbackDrawerItem>
				<FeedbackDrawerTitle>Complaint:</FeedbackDrawerTitle>
				<FeedbackDrawerValue>{selectedItem?.complaint}</FeedbackDrawerValue>
			</FeedbackDrawerItem>
			<FeedbackDrawerItem>
				<FeedbackDrawerTitle>User:</FeedbackDrawerTitle>
				<LinkView to={AppRoutes.UserEdit.buildPath({ id: selectedItem?.userId ?? 0 })} target="_blank">
					{selectedItem.userName}
				</LinkView>
			</FeedbackDrawerItem>
		</Col>
	);
});
